import { useCallback, useMemo } from "react";
import debounce from "lodash-es/debounce";
import { useQuery } from "@apollo/client";
import { ActivityCategory, getActivitiesGQL } from "@onmo/graphql/graphql";
import { PRODUCT_QUERY } from "../constants/achievement";

const LIMIT_ACTIVITIES = 20;

export const useActivities = () => {
  const { data, fetchMore, loading } = useQuery(getActivitiesGQL, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        category: ActivityCategory.Profile,
        page: {
          limit: LIMIT_ACTIVITIES,
          offset: 0,
        },
        products: PRODUCT_QUERY,
      },
    },
  });

  const loadMore = useCallback(async () => {
    try {
      const currentCount = data?.me?.activities?.items?.length ?? 0;
      if (currentCount >= data?.me?.activities?.total) return;
      await fetchMore({
        variables: {
          input: {
            category: ActivityCategory.Profile,
            page: {
              limit: LIMIT_ACTIVITIES,
              offset: currentCount,
            },
            products: PRODUCT_QUERY,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  }, [data, fetchMore]);

  const loadMoreActivity = useMemo(() => debounce(loadMore, 300), [loadMore]);

  return {
    activities: data?.me?.activities?.items,
    loadMoreActivity,
    loading,
  };
};
